export default __webpack_public_path__ + "static/media/img-0030.fd27bc2e.png";